import React, { useState, useEffect } from 'react'
import './styles/CustomUpcoming.css'
import { eventTypeColors } from '../constants/colors';
import { months } from '../constants/dateTime';
import { types } from '../constants/eventVars';
import { displayEventTime } from '../utils/datetime';

function getWeekdayAbbrev(year, monthIndex, day) {
    return new Date(year, monthIndex, day).toLocaleDateString('en-US', { weekday: 'short' });
}

export default function CustomUpcoming({ filtersSelected, dayOfMonth, currentMonth, eventsData, openModal, year }) {

    const [upcomingEvents, setupcomingEvents] = useState({});
    const badgeYear = year || new Date().getFullYear();

    useEffect(() => {
        if (eventsData) {
            compileUpcomingEvents()
        }
    }, [eventsData]);

    function compileUpcomingEvents() {
        setupcomingEvents(eventsData)
    }

    function renderUpcomingEventsData() {
        const componentsToRender = []


        Object.keys(upcomingEvents).forEach(key => {//compiledEventsThisMonth and compiledEventsNextMonth
            let keyPrefix = 'a'
            let monthIndexForKey = currentMonth
            if (key === 'compiledEventsNextMonth') {
                keyPrefix = 'b'
                monthIndexForKey = currentMonth + 1
                componentsToRender.push(
                    <div key={'nextMonthLine'} className='upcoming-month-divider'>
                        <span>{months[currentMonth + 1]}</span>
                    </div>
                )
            }

            const upcomingEventsForSingleMonth = upcomingEvents[key]

            Object.keys(upcomingEventsForSingleMonth).forEach((dayOfMonthKey, index) => {
                upcomingEventsForSingleMonth[dayOfMonthKey].map((eventObj, subIndex) => {
                    const eventType = eventObj.badge === "yes" ? 'temp' : (types.includes(eventObj?.type) ? eventObj?.type : 'other')
                    if (filtersSelected.includes(eventType) || eventType === 'other' || eventType === "temp") {
                        componentsToRender.push(
                            <div onClick={() => openModal('event', { eventData: { ...eventObj } })} key={keyPrefix + ' ' + index + "-" + subIndex}
                                className={'upcoming-event-card'}>
                                <div className='upcoming-date-badge'>
                                    <span className='upcoming-date-dow'>{getWeekdayAbbrev(badgeYear, monthIndexForKey, Number(dayOfMonthKey))}</span>
                                    <span className='upcoming-date-day'>{dayOfMonthKey}</span>
                                </div>
                                <div className='upcoming-dot' style={{ backgroundColor: eventTypeColors[eventType].mid }}></div>
                                <div className='upcoming-event-info'>
                                    <h4 className='upcoming-event-title'>{eventObj.title}</h4>
                                    <p className='upcoming-event-meta'>
                                        {displayEventTime(eventObj)}
                                        {eventObj?.location?.name ? ` · ${eventObj.location.name}` : ''}
                                    </p>
                                </div>
                            </div>
                        )
                    }
                })
            })
        });

        return componentsToRender
    }

    const upcomingItems = renderUpcomingEventsData();

    return (
        <div className='upcoming-container'>
            <div className='upcoming-header-container'>
                <h3 className='upcoming-title'>Upcoming</h3>
            </div>
            <div className='upcoming-body-container'>
                <div className='upcoming-events-container'>
                    {upcomingItems.length > 0 ? upcomingItems : (
                        <div className='upcoming-empty-state'>No upcoming events</div>
                    )}
                </div>
            </div>
        </div>
    )
}
